import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "filter-chevron-right",
  "use": "filter-chevron-right-usage",
  "viewBox": "0 0 8 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 8 12\" id=\"filter-chevron-right\"><path d=\"M4.586 6.05.343 10.293l1.414 1.414L7.414 6.05 1.757.393.343 1.807z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol